"use client";

import React, { useEffect } from "react";

import { ServiceErrorPage } from "~/components/service-error-page/component";
import { NRManagableError } from "~/components/service-error-page/components/new-relic-integration/types";

import { Logger } from "../utils/logger";

export default function ErrorPage({ error }: Readonly<{ error: NRManagableError }>) {
  useEffect(() => {
    Logger.getLogger("ErrorPage").error(
      `${error.name}[${error.cause}]: ${error.message}. See details: ${error.digest}`,
    );
  }, [error]);

  return <ServiceErrorPage error={error} />;
}
